module.exports = __webpack_public_path__ + "images/videoCaseStudy-nivea-challenge-float01.jpg?h=37f4280d4a46134a9d1d8ef7ca98267c";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-challenge-float01.jpg
// module id = 2111
// module chunks = 12 15